// Auto-linkifies recognized domains, URLs, emails, and phone numbers within plain text.
// Returns an array of strings + JSX <a> elements suitable for rendering inside a React node.

import React from 'react';

const RULES = [
  // longest / most-specific first
  {
    re: /columbus\.in\.gov\/public-works/gi,
    href: () => 'https://www.columbus.in.gov/public-works/',
  },
  { re: /columbus\.in\.gov/gi, href: () => 'https://www.columbus.in.gov' },
  { re: /www\.bcswmd\.com/gi, href: () => 'https://www.bcswmd.com' },
  { re: /bcswmd\.com/gi, href: () => 'https://www.bcswmd.com' },
  { re: /in\.gov\/idem/gi, href: () => 'https://www.in.gov/idem/' },
  { re: /in\.gov\/indot/gi, href: () => 'https://www.in.gov/indot/' },
  { re: /epa\.gov\/smm/gi, href: () => 'https://www.epa.gov/smm' },
  { re: /www\.gohighlevel\.com\/privacy-policy/gi, href: () => 'https://www.gohighlevel.com/privacy-policy' },
  { re: /ohanapropertyexperts\.com/gi, href: () => 'https://ohanapropertyexperts.com' },
  { re: /https?:\/\/[^\s)]+/gi, href: (m) => m },
  // email
  { re: /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, href: (m) => `mailto:${m}`, internal: true },
  // phone like (812) 302-6833 or 812-376-2614
  {
    re: /\((\d{3})\)\s*(\d{3})-(\d{4})/g,
    href: (m) => `tel:+1${m.replace(/\D/g, '')}`,
    internal: true,
  },
  { re: /\b(\d{3})-(\d{3})-(\d{4})\b/g, href: (m) => `tel:+1${m.replace(/\D/g, '')}`, internal: true },
];

const LINK_CLASS =
  'text-ohana-primary font-semibold underline decoration-ohana-accent decoration-2 underline-offset-4 hover:text-ohana-accent-dark';

export function linkify(text) {
  if (!text || typeof text !== 'string') return text;

  // Build composite regex preserving rule order via alternation groups.
  const composite = new RegExp(
    RULES.map((r) => `(${r.source || r.re.source})`).join('|'),
    'gi',
  );

  const parts = [];
  let last = 0;
  let m;
  while ((m = composite.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const matched = m[0];
    const rule = RULES.find((r) => new RegExp(`^(?:${r.re.source})$`, 'i').test(matched));
    const href = rule ? rule.href(matched) : matched;
    const isInternal = rule?.internal === true;
    parts.push(
      <a
        key={`lnk-${m.index}-${matched.length}`}
        href={href}
        {...(isInternal ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
        className={LINK_CLASS}
      >
        {matched}
      </a>,
    );
    last = m.index + matched.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts.length ? parts : text;
}
